import React, { useEffect, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import * as Utils from '../../commons/utils/Utils';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Radio,
  FormControlLabel,
  RadioGroup
} from '@material-ui/core';
import { StyledTableCell } from '../../commons/utils/TableStyles';
import Timezone from '../../commons/timezone/Timezone.js';
import { StyledTooltip } from '../../commons/utils/TableStyles';
import $ from 'jquery';
import CecosGrid from './CecosGrid.js';
import LogoCompany from '../../assets/images/logo-company-login-tc-print.png'
import LogoVecFleet from '../../assets/images/logo-vecfleet.png'
import Security from '../../commons/security/Security.js';

const HistoricoAdmGrid = (props) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const [radioValue, setRadioValue] = useState('tjtComb');
  const [tjtComData, setTjtComData] = useState(null);
  const [observaciones, setObservaciones] = useState(null);
  const [transportadoraData, setTransportadoraData] = useState(null);
  const [valorContableData, setValorContableData] = useState(null);

  const handleChangeRadio = (event) => {
    setRadioValue(event.target.value)
  }

  const handleExport = () => {
    let data = null;
    switch (radioValue) {
      case 'tjtComb':
        data = tjtComData;
        break;
      default:
        break;
    }

    data = data.map(e => {
      e = {...e};
      e.usuario = e.usuario.nombreApellido;
      return e;
    })

    let auxDataToExport = JSON.stringify({
      dataToExport: data,
      entidad: radioValue
    });

    Utils.sendDataBlob(`/moviles/exportar-historico-datos-generales`, 'POST', auxDataToExport)
      .then((data) => {
        let fileBlob = new File([data], 'historico-datos-generales.xlsx')
        let fileUrl = URL.createObjectURL(fileBlob);
        $("<a />", {
          href: fileUrl,
          download: "historico-tjt-combustible.xlsx"
        }).appendTo("body").get(0).click();
      })
      .catch(() => {
      })
  }

  const handleExportTransportadora = () => {
    let auxDataToExport = JSON.stringify({
      movilId: props.movilId,
    });
    Utils.sendDataBlob(`/historico-transportadora/exportar-excel`, 'POST', auxDataToExport)
      .then((data) => {
        let fileBlob = new File([data], 'historico-datos-generales.xlsx')
        let fileUrl = URL.createObjectURL(fileBlob);
        $("<a />", {
          href: fileUrl,
          download: "historico-transportadoras-moviles.xlsx"
        }).appendTo("body").get(0).click();
      })
      .catch(() => {
      })
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [tjtComResponse, obsResponse, transportadoraResponse, valorContableResponse ] = await Promise.all([
          Utils.getData(`/moviles/${props.movilId}/tarjeta_combustible/grid`),
          Utils.getData(`/moviles/${props.movilId}/observaciones/grid`),
          Utils.getData(`/historico-transportadora?movil_id=${props.movilId}`),
          Utils.getData(`/historico-valor-contable?movil_id=${props.movilId}`) 
        ]);
        setTjtComData(tjtComResponse.data);
        setObservaciones(obsResponse);
        setTransportadoraData(transportadoraResponse);
        setValorContableData(valorContableResponse);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [props.movilId]);

  return (
    <div className="card">
      <div className="card-content">
        <div className="card-body">
          <div className="container-fluid mb-1">
            <div className="row dt-icons">
              <div className="col-md-11">
                <RadioGroup row value={radioValue} onChange={handleChangeRadio}>
                  <FormControlLabel
                    value="tjtComb"
                    label={<FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.radio.tjtCombustible.label" defaultMessage="Tarjeta Combustible" />}
                    control={<Radio color="default" />}
                  />
                  <FormControlLabel
                    value="ceco"
                    label={<FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.radio.cecos.label" defaultMessage="CECOs" />}
                    control={<Radio color="default" />}
                  />
                  <FormControlLabel
                    value="obs"
                    label={<FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.radio.observaciones.label" defaultMessage="Observaciones" />}
                    control={<Radio color="default" />}
                  />
                  <FormControlLabel
                    value="transportadora"
                    label={<FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.radio.transportadora.label" defaultMessage="Transportadora" />}
                    control={<Radio color="default" />}
                  />
                  <FormControlLabel
                    value="valorContable"
                    label={<FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.radio.valor_contable.label" defaultMessage="Valor Contable" />}
                    control={<Radio color="default" />}
                  />
                </RadioGroup>
              </div>
              {radioValue === 'tjtComb' &&
                <div className="col-md-1">
                  <div style={{ marginLeft: "85px" }}>
                    <StyledTooltip
                      title={intl.formatMessage({
                        id: 'movilesAbm.historicoAdmGenerales_modal.tools_export.title_exportar_a_excel',
                        defaultMessage: 'Exportar a Excel',
                      })}
                      arrow
                      placement="top"
                    >
                      <button onClick={() => handleExport()} className="btn" type="button">
                        <span>
                          <i className="ft-upload"></i>
                        </span>
                      </button>
                    </StyledTooltip>
                  </div>
                </div>
              }
            </div>
          </div>
          {/* Historico Tarjeta Combustible */}
          {radioValue === 'tjtComb' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_fecha.label" defaultMessage="Fecha" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_tjtCombustible.label" defaultMessage="Tarjeta de combustible" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_personaModificacion.label" defaultMessage="Persona Modificación" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_razonCambio.label" defaultMessage="Razón de cambio" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_comentario.label" defaultMessage="Comentario" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <StyledTableCell colSpan={4} align="center">
                        <FormattedMessage
                          id="Cargando"
                          defaultMessage="Cargando"
                        />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading &&
                    (tjtComData && tjtComData.map((tjtCom, key) => (
                      <TableRow key={key}>
                        <StyledTableCell align="left">{Timezone.getDateForClient(tjtCom.fecha, null, 'DD-MM-YYYY HH:mm')}</StyledTableCell>
                        <StyledTableCell align="left">{tjtCom.tarjetaCombustible}</StyledTableCell>
                        <StyledTableCell align="left">{tjtCom.usuario.nombreApellido}</StyledTableCell>
                        <StyledTableCell align="left">{tjtCom.razon}</StyledTableCell>
                        <StyledTableCell align="left">{tjtCom.comentario}</StyledTableCell>
                      </TableRow>
                    )
                    ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {/* Historico CECOS */}
          {radioValue === 'ceco' &&
            <CecosGrid movilId={props.movilId} movilDominio={props.movilDominio} />
          }
            {/* Historico Observaciones */}
          {radioValue === 'obs' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_fecha.label" defaultMessage="Fecha" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_personaModificacion.label" defaultMessage="Persona Modificación" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_comentario.label" defaultMessage="Comentario" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <StyledTableCell colSpan={4} align="center">
                        <FormattedMessage
                          id="Cargando"
                          defaultMessage="Cargando"
                        />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading &&
                   (Array.isArray(observaciones) && observaciones.map((obs, key) => (
                      <TableRow key={key}>
                        <StyledTableCell align="left">{Timezone.getDateForClient(obs.fecha, null, 'DD-MM-YYYY HH:mm')}</StyledTableCell>
                        <StyledTableCell align="left">{obs.usuario}</StyledTableCell>
                        <StyledTableCell align="left">{obs.comentario}</StyledTableCell>
                      </TableRow>
                    )
                    ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {/** Historico de Transportadora */}
          {radioValue === 'transportadora' &&
          <div>
            <div className="d-flex justify-content-end mb-2">
              <StyledTooltip
                title={intl.formatMessage({
                  id: 'movilesAbm.historicoAdmGenerales_modal.tools_export.title_exportar_a_excel',
                  defaultMessage: 'Exportar a Excel',
                })}
                arrow
                placement="top"
              >
                <button onClick={() => handleExportTransportadora()} className="btn" type="button">
                  <span>
                    <i className="ft-upload"></i>
                  </span>
                </button>
              </StyledTooltip>
            </div>
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_fecha.label" defaultMessage="Fecha" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.transportadora_sumada.label" defaultMessage="Asignación" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.transportadora_quitada.label" defaultMessage="Baja" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.usuario.label" defaultMessage="Usuario" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <StyledTableCell colSpan={4} align="center">
                        <FormattedMessage
                          id="Cargando"
                          defaultMessage="Cargando"
                        />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading &&
                   (transportadoraData && transportadoraData.map((transportadora, key) => (
                    <TableRow key={key}>
                      <StyledTableCell align="left">
                        {Timezone.getDateForClient(transportadora['fecha'], null, 'DD-MM-YYYY HH:mm')}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {(transportadora['nueva_transportadora'] && transportadora['nueva_transportadora'].length > 0)
                          ? transportadora['nueva_transportadora']
                          : '-'}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {(transportadora['antigua_transportadora'] && transportadora['antigua_transportadora'].length > 0)
                          ? transportadora['antigua_transportadora']
                          : '-'}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {transportadora['usuario_id'] || '-'}
                      </StyledTableCell>
                    </TableRow>
                  ))
                  )
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          }
          {/** Historico de Valores contable */}
          {radioValue === 'valorContable' &&
            <div> 
              <TableContainer>
                <Table aria-label="clases table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="left">
                        <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.column_fecha.label" defaultMessage="Fecha" />
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.persona_modificacion_actor.label" defaultMessage="Persona Modificación / Actor" />
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.origen.label" defaultMessage="Origen" />
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.valor_anterior.label" defaultMessage="Valor Anterior" />
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <FormattedMessage id="movilesAbm.historicoAdmGenerales_modal.valor_nuevo.label" defaultMessage="Valor Nuevo" />
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading && (
                      <TableRow>
                        <StyledTableCell colSpan={4} align="center">
                          <FormattedMessage
                            id="Cargando"
                            defaultMessage="Cargando"
                          />
                        </StyledTableCell>
                      </TableRow>
                    )}
                    {!loading &&
                    (valorContableData && valorContableData.map((valorContable, key) => (
                      <TableRow key={key}>
                        <StyledTableCell align="left">
                          {Timezone.getDateForClient(valorContable['created_at'], null, 'DD-MM-YYYY HH:mm')}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          { valorContable['usuario']? valorContable['usuario']['persona_eloquent']['nombre'] + ' ' + valorContable['usuario']['persona_eloquent']['apellido'] : '-'}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          { valorContable['origen']? valorContable['origen'] : '-'}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          { valorContable['valor_contable_anterior']? valorContable['valor_contable_anterior'] : '-'}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          { valorContable['valor_contable_nuevo']? valorContable['valor_contable_nuevo'] : '-'}
                        </StyledTableCell>
                      </TableRow>
                    ))
                    )
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          }
        </div>
      </div>
    </div>
  )
}
export default HistoricoAdmGrid;